<template>
  <div class="order-detail-item">
    <span> 联系电话 </span>
    <span class="order-item-connect">
      <div @dblclick="isEncrypted = !isEncrypted">
        {{ hidePhoneNumber(BasicData.ContactPhone) }}
      </div>
      <div>
        <el-link
          icon="el-icon-folder-opened"
          :underline="false"
          @click="goCallRecords"
        >通话记录</el-link>
        <el-link
          v-show="BasicData.ContactPhone"
          icon="el-icon-phone-outline"
          :underline="false"
          @click="contactClients"
        >联系客户</el-link>
      </div>
    </span>
  </div>
</template>

<script>
import workService from "@/apis/work/index.js";
import getUserInfo from "@/models/userInfo";
import { Dialog } from "vant";
import { isWeiXin } from "@/utils/utils";

export default {
  name: "contactPhone",
  props: {
    BasicData: {
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isWeiXin: isWeiXin(),
      isEncrypted: true,
    };
  },
  created() {
    this.init();
  },

  methods: {
    hidePhoneNumber(phoneNumber) {
      const { BasicData, isEncrypted } = this;
      if (
        phoneNumber &&
        phoneNumber.length === 11 &&
        isEncrypted &&
        BasicData.WorkType === "tpkf"
      ) {
        return (
          phoneNumber.substring(0, 2) + "*******" + phoneNumber.substring(9)
        );
      }
      return phoneNumber; // 如果手机号不是11位，则原样返回
    },
    async init() {
      const { isWeiXin } = this;
      if (isWeiXin) {
        this.userInfo = {
          user_id: this.$route.query.userid,
        };
        return true;
      } else {
        const userInfo = await getUserInfo();
        this.userInfo = userInfo;
        return true;
      }
    },
    goCallRecords() {
      this.$router.push({
        name: "WorkOrderCallRecords",
        query: {
          work_id: this.$route.query.id,
        },
      });
    },
    contactClients() {
      const { BasicData, userInfo } = this;
      Dialog.confirm({
        title: "提示",
        message: "请确认是否联系客户？",
      })
        .then(() => {
          const params = {
            work_id: this.$route.query.id,
            to_user_id: "",
            to_user_name: BasicData.ContactName,
            to_user_phone: BasicData.ContactPhone,
            user_id: userInfo.user_id,
          };
          workService.WorkContactCustomer(params).then((res) => {
            console.log(res);
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style>
</style>